// extracted by mini-css-extract-plugin
export default {"header":"PersonalisedMenteeEmailersAddConfirmModal_header__YJjnT","footer":"PersonalisedMenteeEmailersAddConfirmModal_footer__ToROB"};